import Vue from 'vue'
import VueQuillEditor, { Quill } from "vue-quill-editor";
import { Table, TableRow, TableCell, Contain, TableModule } from 'quill-table-module';
import { ImageDrop } from 'quill-image-drop-module';
import "quill/dist/quill.snow.css";
import 'quill/dist/quill.core.css';
import 'quill-table-module/src/css/quill.table.css';

Quill.register('modules/imageDrop', ImageDrop);
Quill.register(TableCell);
Quill.register(TableRow);
Quill.register(Table);
Quill.register(Contain);
Quill.register('modules/table', TableModule);

Vue.use(VueQuillEditor)